import { Injectable, signal } from '@angular/core';

export interface CourseSelection {
    id: string;
    name: string;
}

@Injectable({ providedIn: 'root' })
export class PredefinedPathwayCourseSelectionService {
    private readonly _selected = signal<CourseSelection | null>(null);

    readonly selected = this._selected.asReadonly();

    select(course: CourseSelection): void {
        this._selected.set(course);
    }

    clear(): void {
        this._selected.set(null);
    }
}
